<script setup lang="ts">
const route = useRoute()
const { formatDate } = useFormatDate()

const labelSlug = computed(() => String(route.params.label ?? ''))

const { data: allPosts } = await useAsyncData(
  `posts-thema-${labelSlug.value}`,
  () => queryCollection('posts').where('published', '=', true).order('date', 'DESC').all()
)

const matching = computed(() => {
  const slug = labelSlug.value
  return (allPosts.value ?? []).filter(p =>
    (p.badge?.label ?? []).some((l: string) => labelToSlug(l) === slug)
  )
})

const labelName = computed(() => {
  for (const p of allPosts.value ?? []) {
    const found = (p.badge?.label ?? []).find((l: string) => labelToSlug(l) === labelSlug.value)
    if (found) return found
  }
  return labelSlug.value
})

if (matching.value.length === 0) {
  throw createError({ statusCode: 404, statusMessage: 'Thema nicht gefunden', fatal: true })
}

const title = `Blog: ${labelName.value}`
const description = `Alle Blogbeiträge zum Thema "${labelName.value}".`

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description
})

defineOgImageComponent('Saas')
</script>

<template>
  <UContainer>
    <UPageHeader
      :title="`Thema: ${labelName}`"
      :description="`Alle Blogbeiträge zum Thema &quot;${labelName}&quot;.`"
      class="py-[50px]"
    >
      <template #links>
        <UButton
          to="/blog"
          variant="subtle"
          icon="i-lucide-arrow-left"
        >
          Alle Beiträge
        </UButton>
      </template>
    </UPageHeader>

    <UPageBody>
      <UBlogPosts>
        <UBlogPost
          v-for="(post, index) in matching"
          :key="index"
          :to="post.path"
          :title="post.title"
          :description="post.description"
          :image="post.image"
          :date="post.date"
          :authors="post.authors"
          :badge="post.badge?.label?.[0] ? { label: post.badge.label[0] } : undefined"
          orientation="vertical"
          variant="naked"
          :ui="{
            description: 'line-clamp-2'
          }"
        >
          <template #date>
            {{ formatDate(post.date) }}
          </template>
        </UBlogPost>
      </UBlogPosts>
    </UPageBody>
  </UContainer>
</template>
